import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mahaparinirvan-diwas',
  templateUrl: './mahaparinirvan-diwas.component.html',
  styleUrls: ['./mahaparinirvan-diwas.component.scss']
})
export class MahaparinirvanDiwasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
